import React, { useState, useEffect } from 'react';
import axios from 'axios';

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 1000,
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    backdropFilter: 'blur(4px)',
  },
  modal: {
    background: '#111111', border: '1px solid #2a2a2a', padding: '48px',
    width: '100%', maxWidth: '560px', maxHeight: '85vh', overflowY: 'auto', position: 'relative',
  },
  close: {
    position: 'absolute', top: '20px', right: '24px', background: 'none',
    border: 'none', color: '#a09890', fontSize: '1.2rem', cursor: 'pointer',
  },
  eyebrow: {
    fontFamily: 'Jost, sans-serif', fontSize: '0.7rem', fontWeight: 400,
    letterSpacing: '0.4em', textTransform: 'uppercase', color: '#c9a96e', marginBottom: '16px',
  },
  title: {
    fontFamily: 'Cormorant Garamond, serif', fontSize: '2rem',
    fontWeight: 300, color: '#f5f0eb', marginBottom: '32px',
  },
  searchInput: {
    width: '100%', background: '#1a1a1a', border: '1px solid #2a2a2a',
    padding: '14px 16px', color: '#f5f0eb', fontFamily: 'Jost, sans-serif',
    fontSize: '0.85rem', fontWeight: 300, outline: 'none', marginBottom: '8px',
    boxSizing: 'border-box',
  },
  searchResults: {
    border: '1px solid #2a2a2a', background: '#1a1a1a',
    maxHeight: '200px', overflowY: 'auto', marginBottom: '24px',
  },
  searchResult: {
    padding: '12px 16px', cursor: 'pointer',
    borderBottom: '1px solid #2a2a2a', transition: 'background 0.2s ease',
  },
  searchResultName: {
    fontFamily: 'Cormorant Garamond, serif', fontSize: '1.1rem',
    color: '#f5f0eb', marginBottom: '2px',
  },
  searchResultBrand: {
    fontFamily: 'Jost, sans-serif', fontSize: '0.7rem',
    color: '#a09890', letterSpacing: '0.1em',
  },
  selected: {
    background: '#1a1a1a', border: '1px solid #c9a96e', padding: '16px', marginBottom: '24px',
  },
  selectedName: {
    fontFamily: 'Cormorant Garamond, serif', fontSize: '1.3rem', color: '#f5f0eb', marginBottom: '4px',
  },
  selectedBrand: {
    fontFamily: 'Jost, sans-serif', fontSize: '0.7rem',
    color: '#c9a96e', letterSpacing: '0.2em', textTransform: 'uppercase',
  },
  label: {
    fontFamily: 'Jost, sans-serif', fontSize: '0.7rem', fontWeight: 400,
    letterSpacing: '0.2em', textTransform: 'uppercase', color: '#a09890',
    marginBottom: '8px', display: 'block',
  },
  input: {
    width: '100%', background: '#1a1a1a', border: '1px solid #2a2a2a',
    padding: '14px 16px', color: '#f5f0eb', fontFamily: 'Jost, sans-serif',
    fontSize: '0.85rem', fontWeight: 300, marginBottom: '20px', outline: 'none',
    boxSizing: 'border-box',
  },
  select: {
    width: '100%', background: '#1a1a1a', border: '1px solid #2a2a2a',
    padding: '14px 16px', color: '#f5f0eb', fontFamily: 'Jost, sans-serif',
    fontSize: '0.85rem', fontWeight: 300, marginBottom: '20px', outline: 'none',
    cursor: 'pointer', appearance: 'none', boxSizing: 'border-box',
  },
  row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' },
  button: {
    width: '100%', background: '#c9a96e', border: 'none', padding: '16px',
    color: '#0a0a0a', fontFamily: 'Jost, sans-serif', fontSize: '0.75rem',
    fontWeight: 400, letterSpacing: '0.2em', textTransform: 'uppercase',
    cursor: 'pointer', marginTop: '8px',
  },
  outlineBtn: {
    width: '100%', background: 'none', border: '1px solid #2a2a2a', padding: '14px',
    color: '#665e58', fontFamily: 'Jost, sans-serif', fontSize: '0.7rem',
    letterSpacing: '0.2em', textTransform: 'uppercase', cursor: 'pointer', marginTop: '8px',
  },
  divider: { border: 'none', borderTop: '1px solid #2a2a2a', margin: '24px 0' },
  requestLink: {
    fontFamily: 'Jost, sans-serif', fontSize: '0.75rem', color: '#c9a96e',
    textAlign: 'center', padding: '16px', cursor: 'pointer',
    textDecoration: 'underline', textUnderlineOffset: '3px',
  },
  noResults: {
    fontFamily: 'Jost, sans-serif', fontSize: '0.78rem', color: '#3a3a3a',
    textAlign: 'center', padding: '20px',
  },
  error: { color: '#e07070', fontFamily: 'Jost, sans-serif', fontSize: '0.8rem', marginBottom: '16px' },
  success: { color: '#7aad7a', fontFamily: 'Jost, sans-serif', fontSize: '0.8rem', marginBottom: '16px' },
  hint: {
    fontFamily: 'Jost, sans-serif', fontSize: '0.72rem', fontWeight: 300,
    color: '#4a4a4a', lineHeight: 1.7, marginBottom: '24px',
  },
};

const AddFragranceModal = ({ token, onClose, onSuccess, preselected, defaultView, defaultName }) => {
  const [view, setView] = useState(defaultView || 'search'); // 'search' | 'add' | 'request' | 'submitted'
  const [search, setSearch] = useState('');
  const [allFragrances, setAllFragrances] = useState([]);
  const [selected, setSelected] = useState(preselected || null);
  const [bottleSize, setBottleSize] = useState('');
  const [bottlePercentage, setBottlePercentage] = useState(100);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Submission form state
  const [subForm, setSubForm] = useState({ name: defaultName || '', brand: '', type: '' });
  const [subLoading, setSubLoading] = useState(false);
  const [subError, setSubError] = useState('');

  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const res = await axios.get(`${API}/api/fragrances`);
        setAllFragrances(res.data);
      } catch (err) { console.error(err); }
    };
    fetchAll();
    if (preselected) setView('add');
  }, []); // eslint-disable-line

  const filtered = search.length === 0
    ? allFragrances
    : allFragrances.filter(f =>
      f.name.toLowerCase().includes(search.toLowerCase()) ||
      f.brand.toLowerCase().includes(search.toLowerCase())
    );

  const handleSelect = (fragrance) => {
    setSelected(fragrance);
    setSearch('');
    setView('add');
  };

  const handleAddToLibrary = async () => {
    if (!selected) return;
    setError('');
    setLoading(true);
    try {
      await axios.post(
        `${API}/api/library`,
        {
          fragrance_id: selected.fragrance_id || selected.id,
          bottle_size_ml: bottleSize ? parseInt(bottleSize) : null,
          bottle_percentage: parseInt(bottlePercentage),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onSuccess();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    }
    setLoading(false);
  };

  const handleSubmitRequest = async () => {
    if (!subForm.name || !subForm.brand) { setSubError('Please enter a name and brand'); return; }
    setSubLoading(true);
    setSubError('');
    try {
      await axios.post(
        `${API}/api/submissions`,
        { name: subForm.name, brand: subForm.brand, type: subForm.type || null },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setView('submitted');
    } catch (err) {
      setSubError(err.response?.data?.error || 'Something went wrong');
    }
    setSubLoading(false);
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <button style={styles.close} onClick={onClose}>✕</button>

        {/* ── Search view ── */}
        {view === 'search' && (
          <>
            <p style={styles.eyebrow}>My Library</p>
            <h2 style={styles.title}>Add a Fragrance</h2>
            <input
              style={styles.searchInput}
              placeholder="Search by name or brand..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              autoFocus
            />
            <div style={styles.searchResults}>
              {search.length > 0 && filtered.length === 0 ? (
                <div>
                  <p style={styles.noResults}>No results for "{search}"</p>
                  <p style={styles.requestLink} onClick={() => {
                    setSubForm({ name: search, brand: '', type: '' });
                    setView('request');
                  }}>
                    Request this fragrance be added →
                  </p>
                </div>
              ) : filtered.map(f => (
                <div
                  key={f.id}
                  style={styles.searchResult}
                  onClick={() => handleSelect(f)}
                  onMouseEnter={e => e.currentTarget.style.background = '#222222'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <p style={styles.searchResultName}>{f.name}</p>
                  <p style={styles.searchResultBrand}>{f.brand}</p>
                </div>
              ))}
            </div>
            <p style={styles.requestLink} onClick={() => { setSubForm({ name: '', brand: '', type: '' }); setView('request'); }}>
              Can't find your fragrance? Request it be added
            </p>
          </>
        )}

        {/* ── Add to library view ── */}
        {view === 'add' && selected && (
          <>
            <p style={styles.eyebrow}>My Library</p>
            <h2 style={styles.title}>Add to Library</h2>
            <div style={styles.selected}>
              <p style={styles.selectedBrand}>{selected.brand}</p>
              <p style={styles.selectedName}>{selected.name}</p>
            </div>
            {error && <p style={styles.error}>{error}</p>}
            <div style={styles.row}>
              <div>
                <label style={styles.label}>Bottle Size (ml)</label>
                <input style={styles.input} placeholder="e.g. 100" value={bottleSize} onChange={e => setBottleSize(e.target.value)} type="number" />
              </div>
              <div>
                <label style={styles.label}>Bottle Level (%)</label>
                <input style={styles.input} value={bottlePercentage} onChange={e => setBottlePercentage(e.target.value)} type="number" min="0" max="100" />
              </div>
            </div>
            <button style={styles.button} onClick={handleAddToLibrary} disabled={loading}>
              {loading ? 'Adding...' : 'Add to My Library'}
            </button>
            <hr style={styles.divider} />
            <p style={{ ...styles.requestLink, color: '#3a3a3a' }} onClick={() => setView('search')}>← Search again</p>
          </>
        )}

        {/* ── Request submission view ── */}
        {view === 'request' && (
          <>
            <p style={styles.eyebrow}>Request a Fragrance</p>
            <h2 style={styles.title}>Submit a request</h2>
            <p style={styles.hint}>
              Tell us what you're looking for. Our team will verify and add it to the library — usually within 48 hours. We'll email you when it's ready.
            </p>
            <label style={styles.label}>Fragrance Name *</label>
            <input
              style={styles.input}
              placeholder="e.g. Bleu de Chanel"
              value={subForm.name}
              onChange={e => setSubForm(f => ({ ...f, name: e.target.value }))}
            />
            <label style={styles.label}>Brand *</label>
            <input
              style={styles.input}
              placeholder="e.g. Chanel"
              value={subForm.brand}
              onChange={e => setSubForm(f => ({ ...f, brand: e.target.value }))}
            />
            <label style={styles.label}>Type (optional)</label>
            <select
              style={styles.select}
              value={subForm.type}
              onChange={e => setSubForm(f => ({ ...f, type: e.target.value }))}
            >
              <option value="">Select...</option>
              <option>Eau de Parfum</option>
              <option>Eau de Toilette</option>
              <option>Parfum</option>
              <option>Eau de Cologne</option>
              <option>Extrait de Parfum</option>
            </select>
            {subError && <p style={styles.error}>{subError}</p>}
            <button style={styles.button} onClick={handleSubmitRequest} disabled={subLoading}>
              {subLoading ? 'Submitting...' : 'Submit Request'}
            </button>
            <button style={styles.outlineBtn} onClick={() => setView('search')}>← Back to Search</button>
          </>
        )}

        {/* ── Submitted confirmation view ── */}
        {view === 'submitted' && (
          <>
            <p style={styles.eyebrow}>Request Received</p>
            <h2 style={styles.title}>Thank you</h2>
            <p style={styles.hint}>
              We've received your request for <strong style={{ color: '#f5f0eb' }}>{subForm.brand} {subForm.name}</strong>. Our team will verify and add it within 48 hours — we'll email you as soon as it's live.
            </p>
            <button style={styles.button} onClick={onClose}>Done</button>
          </>
        )}
      </div>
    </div>
  );
};

export default AddFragranceModal;